module.exports = __webpack_public_path__ + "img/m10.6886c506.png";